import './styles.css'
import { icons } from '../../../assets/icons'

export const ExactianLoader = () => {
    return (
        <div className="position-relative d-flex justify-content-center align-items-center animate__animated animate__zoomIn">
            {Array.from({ length: 8 }).map((_, index) => (
                <div
                    key={index}
                    className={`position-absolute border border-4 exactian-loader-ring`}
                    style={{
                        padding: `${index * 30}px`,
                        borderRadius: "50%",
                        clipPath: "polygon(0 0, 100% 0, 100% 90%, 0 90%)",
                        borderColor: "var(--new-orange) !important",
                        animation: `rotate ${2 + index * 0.2}s linear infinite ${index % 2 === 0 ? 'normal' : 'reverse'}`,
                        animationDelay: `0s`
                    }}
                />
            ))}
            <div className="d-flex justify-content-center align-items-center black-bg rounded-circle position-relative p-5">
                <img
                    src={icons.exactianLogoWhite}
                    alt="exactian-logo"
                    width={70}
                    style={{ objectFit: 'contain' }}
                />
            </div>
        </div>
    )
}
